class FormService {
    static getForm(url) {
        return $.get({url});
    }

    static postForm(url, data) {
        return $.get({
            method: 'POST',
            url,
            data: new FormData(data),
            processData: false,
            contentType: false
        });
    }
}

export default FormService;


// WEBPACK FOOTER //
// ./assets/js/utils/form-service.js